module.exports = __webpack_public_path__ + "img/icone-send.de8e7c07.png";